const Params = {
    weburl : 'http://localhost:3001',
    profileUrl : 'https://profile.wirestay.com/web/images',
    baseURL: 'https://api.wirestay.com/api/v1',
    endpoints: {
      countryList : '/country/list',
      stateList : '/country/state-list',
      cityList : '/country/city-list',
      createOtp : '/otp/create-otp',
      verifyOtp : '/otp/verify-otp',
      verifyGst : '/captain-profile/verify-gstin',
      isUserExist : '/stays-host-profile/is-user-exists',
      saveProfile : '/stays-host-profile/save-profile',
      updateProfile : '/stays-host-profile/update-profile',
      getProfile : '/stays-host-profile/get-profile',
      updateExtraProfile : '/stays-host-extra-profile/save-profile',
      getExtraProfile : '/stays-host-extra-profile/get-profile',
      updateSpotlight : '/stays-host-extra-profile/save-spotlight',
      getSpotlight : '/stays-host-extra-profile/get-spotlight',
      getTripCategory : '/stays-host/trip-category',
      getMyBooking : '/stays-host/my-bookings',
      getMyCalendar : '/stays-host/my-calendar',
      getDaywisePrice : '/stays-host/my-daywise-price',
      updateDaywisePrice : '/stays-host/update-daywise-price',
      getMyListings : '/stays-host/my-listings',
      checkAffiliate : '/stays-host/check-for-affiliate',
      createListing : '/stays-host/init-listing',
      updateListing : '/stays-host/update-listing',
      getListingData : '/stays-host/get-listing',
      updateImages : '/stays-host/update-featured-images',
      makeItCover : '/stays-host/make-it-cover-image',
      removePhoto : '/stays-hotel/remove-listing-photo',
      getCategories : '/stays-host/categories',
      getAmenities : '/stays-host/amanities',
      findPlaces : '/stays-host/find-places',
      findPlaceById : '/stays-host/find-place-by-id',
      getPendingListings : '/stays-host/pending-listings',
      verifyDocument : '/stays-host/verify-document',
      getChatdb : '/stay-chat/getdb',
      chatMyRequests : '/stay-chat/my-requests',
      latestMessages : '/stay-chat/latest-messages',
      sendMessage : '/stay-chat/send-message',
      sendImage : '/stay-chat/host-media',
      notificationCategory : '/stay-notification/get-host-category',
      notificationList : '/stay-notification/notification-list',
      getUserDetails : '/stays-user-extra/guest-details',
      getBookings : '/stays-hotel/get-bookings',
      bookingInfo : '/stays-host/booking-info',
      saveCheckin : '/stays-hotel/save-host-checkin',
      getBookingDetails : '/stays-hotel/get-booking-details',
      saveCheckout : '/stays-hotel/save-checkout',
      hotelDataList : '/stays-hotel/hotel-data-list',
      getEarnings : '/stays-hotel/get-earning',
      getMyEarnings : '/stays-host-profile/my-earnings',
      earningReportLink : '/stays-host-profile/my-earnings-report-link',
      cancelBooking : '/stays-host/cancel-booking',
      taggingRequest : '/stays-interior-designer/list',
      updateStatus : '/stays-interior-designer/update-status',
      saveVideo : '/stays-host-video/save-entry',
      videoList : '/stays-host-video/list',
      ratingList : '/stays-hotel/get-rating',
      saveReply : '/stays-hotel/save-rating-reply',
      accOffers : '/acc/offers',
      activateOffer : '/acc/pull',
      accelerateHistory : '/acc/history',
      saveCoHost : '/stay-co-host-profile/save-profile',
      updateCoHost : '/stay-co-host-profile/update-profile',
      coHostList : '/stay-co-host-profile/co-hosts-list',
      coHostProfile : '/stay-co-host-profile/get-profile',
      deleteCoHost : '/stay-co-host-profile/delete-profile',
      coUpdateExtraProfile : '/stays-co-host-extra-profile/save-profile',
      coGetExtraProfile : '/stays-co-host-extra-profile/get-profile',
      coUpdateSpotlight : '/stays-co-host-extra-profile/save-spotlight',
      coGetSpotlight : '/stays-co-host-extra-profile/get-spotlight',
      getSubscriptions : '/stays-host-subscription/get-subscriptions',
      subscribeIt : '/stays-host-subscription/subscribe-it',
      verifyPg : '/stays-host-subscription/verify-pg',
      mySubscriptions : '/stays-host-subscription/my-subscriptions',
      renewalHistory : '/stays-host-subscription/my-subscription-renewal-history',
      subscriptionDetails : '/stays-host-subscription/get-subscription-detail',
      renewSubscription: '/stays-host-subscription/renew-my-subscription',
      vibeStatus : '/stays-interior-designer/vibe-status',
      hotelDataList : '/stays-hotel/hotel-data-list',
      getBankList : '/stays-hotel/bank-list',
      getLegal : '/stays-host/get-host-legal',
      updateLegal : '/stays-host/update-host-legal',
      verifyUserDocument : '/stays-hotel/verify-user-document',
      underReview : '/stays-host/under-review',
      deleteListing : '/stays-host/delete-listing',
      payoutBaseData : '/stays-host-payout/base-data',
      payoutMyMethods : '/stays-host-payout/my-methods',
      payoutAddMethod : '/stays-host-payout/add-update-method',
      payoutIfsCode : '/stays-host-payout/ifsc-check',
      listingReports : '/stays-host/reported-listing',
      listingReportReply : '/stays-host/reported-reply',
      saveVisitor : '/app-visitors/stay-save-visitor',
      blogData : '/stays-host-blog/list',
      blogDetails : '/stays-host-blog/blog-details',
      approveRejectBooking : '/stays-host/approve-reject-booking'
    },
  };
  
  export default Params;
  